import React, { useState, useEffect } from "react";
import StatsCard from "./StatsCard";
import api from "../utils/api";
import "../Admin.css";

const Dashboard = () => {
  const [refreshKey] = useState(0);
  const [stats, setStats] = useState({
    total: 0,
    active: 0,
    totalValue: 0,
    categories: 0,
    blogPosts: 0,
    avgDiscount: 0,
    storeCount: 0
  });
  const [recentPosts, setRecentPosts] = useState([]);
  const [topLojas, setTopLojas] = useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.get("/ofertas");
        const offers = response.data;

        const total = offers.length;
        const active = offers.filter(o => o.status === "ATIVA").length;
        const totalValue = offers.reduce((acc, curr) => acc + (parseFloat(curr.preco_desconto) || 0), 0);
        
        // Calcular desconto médio
        const discounts = offers
          .filter(o => o.preco_original > 0 && o.preco_desconto > 0)
          .map(o => ((o.preco_original - o.preco_desconto) / o.preco_original) * 100);
        const avgDiscount = discounts.length > 0 
          ? (discounts.reduce((a, b) => a + b, 0) / discounts.length).toFixed(1) 
          : 0;

        // Distribuição por loja
        const stores = {};
        offers.forEach(o => {
          stores[o.loja] = (stores[o.loja] || 0) + 1;
        });
        const sortedStores = Object.entries(stores)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 5);
        
        setTopLojas(sortedStores);

        const blogResponse = await api.get("/blog");
        const categoriesResponse = await api.get("/api/categorias").catch(() => ({ data: [] }));

        setStats({
          total,
          active,
          totalValue,
          categories: categoriesResponse.data.length || 0,
          blogPosts: blogResponse.data.length,
          avgDiscount,
          storeCount: Object.keys(stores).length
        });

        setRecentPosts(blogResponse.data.slice(0, 5));
      } catch (error) {
        console.error("Erro ao carregar estatísticas", error);
      }
    };
    fetchStats();
  }, [refreshKey]);

  return (
    <>
      <div className="page-header">
        <h2>Dashboard Analítico</h2>
      </div>

      {/* Stats Grid */}
      <div className="stats-grid">
        <StatsCard
          title="Total de Ofertas"
          value={stats.total}
          icon="fas fa-box-open"
          color="#3483fa"
        />
        <StatsCard
          title="Ofertas Ativas"
          value={stats.active}
          icon="fas fa-check-circle"
          color="#00a650"
        />
        <StatsCard
          title="Valor em Estoque"
          value={new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(stats.totalValue)}
          icon="fas fa-dollar-sign"
          color="#2d3277"
        />
        <StatsCard
          title="Desconto Médio"
          value={`${stats.avgDiscount}%`}
          icon="fas fa-percentage"
          color="#ff9800"
        />
      </div>

      <div className="stats-grid" style={{ marginTop: '20px' }}>
        <StatsCard
          title="Artigos no Blog"
          value={stats.blogPosts}
          icon="fas fa-newspaper"
          color="#e91e63"
        />
        <StatsCard
          title="Categorias"
          value={stats.categories}
          icon="fas fa-tags"
          color="#9c27b0"
        />
        <StatsCard
          title="Lojas Parceiras"
          value={stats.storeCount}
          icon="fas fa-store"
          color="#607d8b"
        />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '30px' }}>
        {/* Top Lojas */}
        <div className="card-container" style={{ margin: 0 }}>
          <div className="card-header">
            <h3>Top Lojas (Volume de Ofertas)</h3>
          </div>
          <div style={{ padding: '0 20px 20px 20px' }}>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Loja</th>
                  <th>Total de Ofertas</th>
                </tr>
              </thead>
              <tbody>
                {topLojas.map(([loja, count]) => (
                  <tr key={loja}>
                    <td>{loja}</td>
                    <td><strong>{count}</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Artigos Recentes */}
        <div className="card-container" style={{ margin: 0 }}>
          <div className="card-header">
            <h3>Artigos Recentes</h3>
          </div>
          <div style={{ padding: '0 20px 20px 20px' }}>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Título</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                {recentPosts.map(post => (
                  <tr key={post.id}>
                    <td>{post.title}</td>
                    <td>{new Date(post.createdAt).toLocaleDateString('pt-BR')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
